if (!customElements.get('wish-list-button')) {
    class WishListButton extends HTMLElement {
        constructor() {
            super();
            this.meta = meta;
            this.isAdded = false;
            this.setupEventForButton();
        }

        // noinspection JSUnusedGlobalSymbols
        connectedCallback() {
            if (!this.rendered) {
                this.init();
            }
        }

        setupData() {
            this.data = {
                productId: parseInt(this.getAttribute('product-id')),
                variantId: parseInt(this.getAttribute('product-variant-id')),
            };
        }

        init() {
            this.setupData();
            this.themeLoaded((swat) => {
                this.swat = swat;
                this.swatData = SwymProductVariants[this.data.variantId];

                if (!this.swatData) {
                    this.swatData = {
                        empi: this.data.productId,
                        epi: this.data.variantId
                    };
                }

                this.render();
            });

            this.rendered = true;
        }

        /**
         * @param addedCallBack
         * @param removedCallBack
         */
        wishListLoader(addedCallBack, removedCallBack) {
            this.swat.fetch((list) => {
                let isInWishList = list.find((item) => {
                    return item.empi === this.data.productId && item.epi === this.data.variantId;
                })

                if (isInWishList) {
                    addedCallBack();
                } else {
                    removedCallBack();
                }
            });
        }

        /**
         * @param callback
         */
        themeLoaded(callback) {
            if (!window.SwymCallbacks) {
                window.SwymCallbacks = [];
            }

            window.SwymCallbacks.push((swat) => {
                callback(swat);
            });
        }

        render() {
            this.wishListLoader(() => {
                this.setWishListAdded();
            }, () => {
                this.setWishListRemoved();
            });
        }

        setupEventForButton() {
            this.addEventListener('click', () => {
                if (this.isAdded) {
                    this.swat.removeFromWishList(this.swatData, () => {
                        this.setWishListRemoved();
                        this.newEventForUpdateStatus();
                    });
                } else {
                    this.swat.addToWishList(this.swatData, () => {
                        this.setWishListAdded();
                        this.newEventForUpdateStatus();
                    });
                }
            });
        }

        setWishListAdded() {
            this.isAdded = true;
            this.classList.remove('added');
            this.classList.add('removed');
        }

        setWishListRemoved() {
            this.isAdded = false;
            this.classList.add('added');
            this.classList.remove('removed');
        }

        newEventForUpdateStatus() {
            this.dispatchEvent(new CustomEvent("changeStatus", { bubbles: true }));
        }
    }

    customElements.define('wish-list-button', WishListButton);
}